/**
 * Check if an HTML string is semantically empty (no visible text content)
 * @param {string} html - The HTML string to check
 * @returns {boolean} - true if empty
 */
export function isEmptyHtml(html) {
    if (!html || !html.trim()) return true;
    const div = document.createElement('div');
    div.innerHTML = html;
    const text = (div.textContent || div.innerText || '').trim();
    return text.length === 0;
}
